import {css} from 'styled-components';

const revCssVariable = `
  --topNavBarHeight: 70px;
  --contentMaxWidth: 1200px;
`;

const revSiteNavBar = `
  #rev-SiteNavBar {
    padding: 10px 40px;
    & > .logo-box > a > img {
      display: none;
    }

    & > .logo-box > a::before {
      content: '';
      display: inline-block;
      background-image: url('/images/site-logo.png');
      background-size: 190px 21px;
      width: 190px;
      height: 21px;
    }
    & > .nav-items {
      justify-content: flex-end;
    }

    & > .nav-items > div, a {
       margin: 0px 8px !important;
    }

    & > .nav-items > div > * {
      max-width: 100px;
      text-align: center;
      text-overflow: ellipsis;
      border-bottom: none !important;
    }
  }
`;

const revSiteFooter = `
  #rev-SiteFooter {
    & > .content > img {
      width: 190px;
      height: 23px;
    }

    & > .content > .lang-selector {
      display: none;
    }
  }
`;

const revProductDetailPage = `
  #rev-ProductDetailPage {
    & > .content > .detail > div > div:nth-child(3) > :not(:nth-child(1),:nth-child(2)) {
     display: none;
    }
  }
`;

export default css`
  ${revCssVariable};
  ${revSiteNavBar};
  ${revSiteFooter};
  ${revProductDetailPage};

  #rev-ProductListPage .rev-FilterMenuL2,
  #rev-ProductDetailPage .rev-FilterMenuL2 {
    position: sticky;
    top: 72px;
    margin: 0px 10px;

    & > .header {
      padding: 23px 0px;
      font-size: 1.25rem;

      & > .label {
        display: none;
      }

      &::before {
        content: '產品列表';
        flex: 1;
        font-size: 1.3rem;
      }
    }

    & > .L1 {
      background-color: transparent;
      border-radius: 0px;
      padding: 0px;
      margin-bottom: 0px;
      box-shadow: none;

      & > .header {
        padding: 10px 0;
        border-top: 1px solid #d0d0d0;
        font-size: 1rem;
        color: #000000;
      }

      & > .L1-items {
        border-top: 1px solid #d0d0d0;
        padding-left: 15px;
        overflow: hidden;

        & > .L2 {
          padding: 5px 10px;
        }

        & > .L2 > .header {
          font-size: 0.95rem;
          color: #6f6f6f;
        }

        & > .L2.selected > .header {
          font-size: 0.95rem;
          color: var(--primaryColor);
        }
      }

      &:last-child {
        border-bottom: 1px solid #d0d0d0;
      }
    }
  }

  #rev-ArticleListPage .rev-FilterMenuL1,
  #rev-ArticleDetailPage .categories {
    display: none;
  }
`;
